module.exports = __webpack_public_path__ + "static/img/b33.f40555a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b33.png
// module id = FA4n
// module chunks = 1